<template>
  <div
    class="Polaris-Page px-6"
    :class="{ 'Polaris-Page--fullWidth': isFullWidth }"
  >
    <div
      class="Polaris-Box"
      style="--pc-box-padding-block-end-xs:var(--p-space-4);--pc-box-padding-block-end-md:var(--p-space-5);--pc-box-padding-block-start-xs:var(--p-space-4);--pc-box-padding-block-start-md:var(--p-space-5);--pc-box-padding-inline-start-xs:var(--p-space-4);--pc-box-padding-inline-start-sm:var(--p-space-0);--pc-box-padding-inline-end-xs:var(--p-space-4);--pc-box-padding-inline-end-sm:var(--p-space-0);position:relative"
    >
      <div
        class="Polaris-Page-Header--noBreadcrumbs Polaris-Page-Header--mediumTitle"
      >
        <div class="Polaris-Page-Header__Row">
          <div v-if="showBack" class="Polaris-Page-Header__BreadcrumbWrapper">
            <div
              class="Polaris-Box Polaris-Box--printHidden"
              style="--pc-box-max-width:100%;--pc-box-padding-inline-end-xs:var(--p-space-4)"
            >
              <nav role="navigation">
                <a
                  class="Polaris-Breadcrumbs__Breadcrumb"
                  @click="goBack"
                  data-polaris-unstyled="true"
                >
                  <span class="Polaris-Breadcrumbs__Icon">
                    <span class="Polaris-Icon">
                      <span
                        class="Polaris-Text--root Polaris-Text--visuallyHidden"
                      >
                      </span>
                      <svg
                        viewBox="0 0 20 20"
                        class="Polaris-Icon__Svg"
                        focusable="false"
                        aria-hidden="true"
                      >
                        <path
                          d="M17 9h-11.586l3.293-3.293a.999.999 0 1 0-1.414-1.414l-5 5a.999.999 0 0 0 0 1.414l5 5a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414l-3.293-3.293h11.586a1 1 0 1 0 0-2z"
                        ></path>
                      </svg>
                    </span>
                  </span>
                </a>
              </nav>
            </div>
          </div>
          <div class="Polaris-Page-Header__TitleWrapper">
            <h1 class="Polaris-Header-Title">{{ title }}</h1>
          </div>
          <div class="Polaris-Page-Header__RightAlign">
            <div class="Polaris-Page-Header__Actions">
              <slot name="action"></slot>
            </div>
          </div>
        </div>
      </div>

      <div><slot></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isFullWidth: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    showBack: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style></style>
